export const CONTEST_PROMO_TILE_FLAG = 'pen-5236_v2'
